import { CoachingEntity } from './coaching-entity.model';
import { DefaultNote } from './default-note.model';
import { NoteCategory } from './note-category.model';

export const NoteEntityType = 'note';

export interface NoteEntity extends CoachingEntity<any> {
    /** stored procedure inflates to an object */
    noteCategories: NoteCategory[];

    defaultNotes?: DefaultNote[];
}
